import { advTypesSelector, contactRolesSelector } from "core/dataConstants";
import log from "loglevel";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { actions } from "./contactActions";

import { createError } from "core/exceptions";
import CompanyService from "services/companyService";
import ContactService from "services/contactService";

export function* saveCompany({ payload }) {
    try {
        let newCompany;
        if (payload.id) {
            newCompany = yield call(CompanyService.editCompany, payload);
        } else {
            newCompany = yield call(CompanyService.saveCompany, payload);
        }
        yield put(actions.SAVE_COMPANY.success(newCompany));
    } catch (e) {
        log.error(e);
        yield put(actions.SAVE_COMPANY.failed(null, createError(e)));
    }
}

export function* removeCompany({ payload }) {
    try {
        yield call(CompanyService.removeCompany, payload);
        yield put(actions.REMOVE_COMPANY.success(payload));
    } catch (e) {
        log.error(e);
        yield put(actions.REMOVE_COMPANY.failed(null, createError(e)));
    }
}

export function* saveContact({ payload }) {
    try {
        let newContact;
        if (payload.id) {
            newContact = yield call(ContactService.editContact, payload);
        } else {
            newContact = yield call(ContactService.saveContact, payload);
        }

        const globalContactRoles = yield select(contactRolesSelector);

        const contactRoles = newContact.contactRolesIds.map((contactId) =>
            globalContactRoles.find((contact) => contact.id === contactId)
        );
        const globalAdvType = yield select(advTypesSelector);
        const advTypes = newContact.advertisementTypesIds.map((advId) => globalAdvType.find((adv) => adv.id === advId));

        newContact = {
            ...newContact,
            advTypes: advTypes,
            contactRoles: contactRoles,
            addressList: [...(newContact.addresses || [])],
        };

        yield put(actions.SAVE_CONTACT.success(newContact));
    } catch (e) {
        log.error(e);
        yield put(actions.SAVE_CONTACT.failed(null, createError(e)));
    }
}

export function* removeContact({ payload }) {
    try {
        yield call(ContactService.removeContact, payload);
        yield put(actions.REMOVE_CONTACT.success(payload));
    } catch (e) {
        log.error(e);
        yield put(actions.REMOVE_CONTACT.failed(null, createError(e)));
    }
}

export function* getCompanyByID({ payload }) {
    try {
        let company = yield call(CompanyService.getCompanyByID, payload);
        yield put(actions.GET_COMPANY.success(company.data));
    } catch (e) {
        yield put(actions.GET_COMPANY.failed(null, createError(e)));
    }
}

export default [
    takeLatest(actions.SAVE_CONTACT.sendType, saveContact),
    takeLatest(actions.REMOVE_CONTACT.sendType, removeContact),
    takeLatest(actions.SAVE_COMPANY.sendType, saveCompany),
    takeLatest(actions.REMOVE_COMPANY.sendType, removeCompany),
    takeLatest(actions.GET_COMPANY.sendType, getCompanyByID),
];
